module.exports = __webpack_public_path__ + "img/soc-marks-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/soc-marks-bg.jpg
// module id = 197
// module chunks = 13